import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FolderDown, ImagePlus } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";
import { LocalPhotos } from "@/components/admin/LocalPhotos";

export const PhotosTab = () => {
  const call = useApi();
  const [info, setInfo] = useState(null);
  const [url, setUrl] = useState("");

  const load = () => call("get", "/admin/drive-photos").then((r) => { setInfo(r.data); setUrl((u) => u || r.data.folder_url || ""); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!info?.running) return undefined;
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [info?.running]);

  const start = async () => {
    try {
      const { data } = await call("post", "/admin/drive-photos/import", { folder_url: url });
      toast.success(`${data.total} fotos encontradas. Importando…`);
      load();
    } catch (e) { toast.error(errMsg(e, "No se pudo leer la carpeta")); }
  };

  const r = info?.result;
  return (
    <div className="space-y-6">
    <LocalPhotos onDone={load} />
    <div className="bg-white border p-6 max-w-3xl space-y-5" data-testid="admin-photos-tab">
      <p className="filter-title flex items-center gap-2"><ImagePlus className="w-4 h-4" /> Fotos desde Google Drive</p>
      <p className="text-sm text-slate-600">El nombre de cada foto debe <b>empezar por la referencia</b> del artículo (ej. <span className="font-mono">EQYFT04856_1.jpg</span>). Si después lleva el color (<span className="font-mono">EQYFT04856_NEGRO_2.jpg</span>) se asigna a ese color. Si el color lleva barra (WDWB/N) escríbelo con guion o sin ella: <span className="font-mono">118851_WDWB-N_1.jpg</span>. Se ordenan por nombre; las ya importadas no se repiten. Puede haber subcarpetas. También sirve para el <b>outlet</b> con la referencia de la hoja (ej. <span className="font-mono">KI1790_1.jpg</span>); si una referencia tiene varios colores, añade el color.</p>
      <label className="block">
        <span className="text-xs font-semibold text-slate-600">Enlace de la carpeta (compartida como "cualquier persona con el enlace")</span>
        <input className="field mt-1" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://drive.google.com/drive/folders/…" data-testid="photos-folder-url" />
      </label>
      <button className="btn-primary !h-11" onClick={start} disabled={info?.running} data-testid="photos-import-button">
        <FolderDown className={`w-4 h-4 ${info?.running ? "animate-bounce" : ""}`} /> {info?.running ? `Importando ${info.done} / ${info.total}…` : "Importar fotos"}
      </button>
      {r && !info.running && (
        <div className="space-y-3 text-sm" data-testid="photos-result">
          <div className="grid sm:grid-cols-3 gap-3">
            <div className="bg-slate-50 p-3"><p className="text-xs text-slate-500">Fotos añadidas</p><p className="font-bold text-lg" data-testid="photos-added">{r.photos}</p></div>
            <div className="bg-slate-50 p-3"><p className="text-xs text-slate-500">Artículos con fotos nuevas</p><p className="font-bold text-lg" data-testid="photos-products">{r.products}</p></div>
            <div className="bg-slate-50 p-3"><p className="text-xs text-slate-500">Ya importadas antes</p><p className="font-bold text-lg">{r.already_imported}</p></div>
          </div>
          {r.unmatched_count > 0 && (
            <div className="border border-amber-300 bg-amber-50 p-4" data-testid="photos-unmatched">
              <p className="font-semibold text-amber-800">{r.unmatched_count} fotos sin artículo con esa referencia:</p>
              <p className="mt-2 text-xs text-amber-900 max-h-40 overflow-y-auto font-mono">{r.unmatched.join(" · ")}</p>
            </div>
          )}
          {r.full?.length > 0 && <p className="text-xs text-amber-700" data-testid="photos-full">No añadidas porque el artículo ya tiene 7 fotos: {r.full.join(", ")}</p>}
          {r.failed?.length > 0 && <p className="text-xs text-rose-600" data-testid="photos-failed">No se pudieron descargar: {r.failed.join(", ")}</p>}
        </div>
      )}
    </div>
    </div>
  );
};
